export const messengerConstants = {
  SET_ORGANIZATIOID: 'MESSENGER/SET_ORGANIZATIOID',
  SET_SIDEBAR_SCREEN: 'MESSENGER/SET_SIDEBAR_SCREEN',

  SEND_MESSAGE: 'MESSENGER/SEND_MESSAGE',
  SEARCH_MEMBER_REQUEST: 'MESSENGER/SEARCH_MEMBER_REQUEST',
  SEARCH_MEMBER_SUCCESS: 'MESSENGER/SEARCH_MEMBER_SUCCESS',
  SEARCH_MEMBER_FAILURE: 'MESSENGER/SEARCH_MEMBER_FAILURE',

  CREATE_CONV_REQUEST: 'MESSENGER/CREATE_CONV_REQUEST',
  CREATE_CONV_SUCCESS: 'MESSENGER/CREATE_CONV_SUCCESS',
  CREATE_CONV_FAILURE: 'MESSENGER/CREATE_CONV_FAILURE',

  RENAME_CONV_REQUEST: 'MESSENGER/RENAME_CONV_REQUEST',
  RENAME_CONV_SUCCESS: 'MESSENGER/RENAME_CONV_SUCCESS',
  RENAME_CONV_FAILURE: 'MESSENGER/RENAME_CONV_FAILURE',

  DELETE_CONV_REQUEST: 'MESSENGER/DELETE_CONV_REQUEST',
  DELETE_CONV_SUCCESS: 'MESSENGER/DELETE_CONV_SUCCESS',
  DELETE_CONV_FAILURE: 'MESSENGER/DELETE_CONV_FAILURE',

  ADD_MEMBERS_TO_CONV_REQUEST: 'MESSENGER/ADD_MEMBERS_TO_CONV_REQUEST',
  ADD_MEMBERS_TO_CONV_SUCCESS: 'MESSENGER/ADD_MEMBERS_TO_CONV_SUCCESS',
  ADD_MEMBERS_TO_CONV_FAILURE: 'MESSENGER/ADD_MEMBERS_TO_CONV_FAILURE',

  REMOVE_MEMBERS_FROM_CONV_REQUEST: 'MESSENGER/REMOVE_MEMBERS_FROM_CONV_REQUEST',
  REMOVE_MEMBERS_FROM_CONV_SUCCESS: 'MESSENGER/REMOVE_MEMBERS_FROM_CONV_SUCCESS',
  REMOVE_MEMBERS_FROM_CONV_FAILURE: 'MESSENGER/REMOVE_MEMBERS_FROM_CONV_FAILURE',

  LEAVE_CONV_REQUEST: 'MESSENGER/LEAVE_CONV_REQUEST',
  LEAVE_CONV_SUCCESS: 'MESSENGER/LEAVE_CONV_SUCCESS',
  LEAVE_CONV_FAILURE: 'MESSENGER/LEAVE_CONV_FAILURE',

  RESUME_CONV_REQUEST: 'MESSENGER/RESUME_CONV_REQUEST',
  RESUME_CONV_SUCCESS: 'MESSENGER/RESUME_CONV_SUCCESS',
  RESUME_CONV_FAILURE: 'MESSENGER/RESUME_CONV_FAILURE',

  MUTE_CONV_REQUEST: 'MESSENGER/MUTE_CONV_REQUEST',
  MUTE_CONV_SUCCESS: 'MESSENGER/MUTE_CONV_SUCCESS',
  MUTE_CONV_FAILURE: 'MESSENGER/MUTE_CONV_FAILURE',

  UNMUTE_CONV_REQUEST: 'MESSENGER/UNMUTE_CONV_REQUEST',
  UNMUTE_CONV_SUCCESS: 'MESSENGER/UNMUTE_CONV_SUCCESS',
  UNMUTE_CONV_FAILURE: 'MESSENGER/UNMUTE_CONV_FAILURE',

  HIDE_CONV_REQUEST: 'MESSENGER/HIDE_CONV_REQUEST',
  HIDE_CONV_SUCCESS: 'MESSENGER/HIDE_CONV_SUCCESS',
  HIDE_CONV_FAILURE: 'MESSENGER/HIDE_CONV_FAILURE',

  POST_MESSAGE_REQUEST: 'MESSENGER/POST_MESSAGE_REQUEST',
  POST_MESSAGE_SUCCESS: 'MESSENGER/POST_MESSAGE_SUCCESS',
  POST_MESSAGE_FAILURE: 'MESSENGER/POST_MESSAGE_FAILURE',

  UPDATE_MESSAGE_REQUEST: 'MESSENGER/UPDATE_MESSAGE_REQUEST',
  UPDATE_MESSAGE_SUCCESS: 'MESSENGER/UPDATE_MESSAGE_SUCCESS',
  UPDATE_MESSAGE_FAILURE: 'MESSENGER/UPDATE_MESSAGE_FAILURE',

  DELETE_MESSAGE_REQUEST: 'MESSENGER/DELETE_MESSAGE_REQUEST',
  DELETE_MESSAGE_SUCCESS: 'MESSENGER/DELETE_MESSAGE_SUCCESS',
  DELETE_MESSAGE_FAILURE: 'MESSENGER/DELETE_MESSAGE_FAILURE',

  SET_ADMIN_REQUEST: 'MESSENGER/SET_ADMIN_REQUEST',
  SET_ADMIN_SUCCESS: 'MESSENGER/SET_ADMIN_SUCCESS',
  SET_ADMIN_FAILURE: 'MESSENGER/SET_ADMIN_FAILURE',

  SET_ORIGIN_MESSAGE: 'MESSENGER/SET_ORIGIN_MESSAGE',
  SHOW_MAIN_CONTENT: 'MESSENGER/SHOW_MAIN_CONTENT',
  SHOW_SIDEBAR: 'MESSENGER/SHOW_SIDEBAR',

  SHOW_HEADER: 'MESSENGER/SHOW_HEADER ',

  CLEAR_ERROR: 'MESSENGER/CLEAR_ERROR',

  ADD_REACTION_REQUEST: 'MESSENGER/ADD_REACTION_REQUEST',
  ADD_REACTION_SUCCESS: 'MESSENGER/ADD_REACTION_SUCCESS',
  ADD_REACTION_FAILURE: 'MESSENGER/ADD_REACTION_FAILURE',

  DELETE_REACTION_REQUEST: 'MESSENGER/DELETE_REACTION_REQUEST',
  DELETE_REACTION_SUCCESS: 'MESSENGER/DELETE_REACTION_SUCCESS',
  DELETE_REACTION_FAILURE: 'MESSENGER/DELETE_REACTION_FAILURE',

  SET_CHANGE_OF_CONVERSATION: 'MESSENGER/SET_CHANGE_OF_CONVERSATION',
  SET_FROM_LIGHT_PROFILE: 'MESSENGER/SET_FROM_LIGHT_PROFILE',

  CREATE_CONV_FROM_LINK_REQUEST: 'MESSENGER/CREATE_CONV_FROM_LINK_REQUEST',
  CREATE_CONV_FROM_LINK_SUCCESS: 'MESSENGER/CREATE_CONV_FROM_LINK_SUCCESS',
  CREATE_CONV_FROM_LINK_FAILURE: 'MESSENGER/CREATE_CONV_FROM_LINK_FAILURE',

  SET_ORGANIZATION_ID: 'MESSENGER/SET_ORGANIZATION_ID',

  REALTIME_CONVERSATIONS_UPDATE_REQUEST: 'MESSENGER/REALTIME_CONVERSATIONS_UPDATE_REQUEST',
  REALTIME_CONVERSATIONS_UPDATE_SUCCESS: 'MESSENGER/REALTIME_CONVERSATIONS_UPDATE_SUCCESS',
  REALTIME_CONVERSATIONS_UPDATE_FAILURE: 'MESSENGER/REALTIME_CONVERSATIONS_UPDATE_FAILURE',

  REALTIME_OPEN_CONVERSATION_UPDATE_REQUEST: 'MESSENGER/REALTIME_OPEN_CONVERSATION_UPDATE_REQUEST',
  REALTIME_OPEN_CONVERSATION_UPDATE_SUCCESS: 'MESSENGER/REALTIME_OPEN_CONVERSATION_UPDATE_SUCCESS',
  REALTIME_OPEN_CONVERSATION_UPDATE_FAILURE: 'MESSENGER/REALTIME_OPEN_CONVERSATION_UPDATE_FAILURE',

  GET_CONVERSATIONS_LIST_REQUEST: 'MESSENGER/GET_CONVERSATIONS_LIST_REQUEST',
  GET_CONVERSATIONS_LIST_SUCCESS: 'MESSENGER/GET_CONVERSATIONS_LIST_SUCCESS',
  GET_CONVERSATIONS_LIST_FAILURE: 'MESSENGER/GET_CONVERSATIONS_LIST_FAILURE',

  GET_CONVERSATIONS_LIST_PAGINATION_REQUEST: 'MESSENGER/GET_CONVERSATIONS_LIST_PAGINATION_REQUEST',
  GET_CONVERSATIONS_LIST_PAGINATION_SUCCESS: 'MESSENGER/GET_CONVERSATIONS_LIST_PAGINATION_SUCCESS',
  GET_CONVERSATIONS_LIST_PAGINATION_FAILURE: 'MESSENGER/GET_CONVERSATIONS_LIST_PAGINATION_FAILURE',

  GET_CONVERSATIONS_SEARCH_REQUEST: 'MESSENGER/GET_CONVERSATIONS_SEARCH_REQUEST',
  GET_CONVERSATIONS_SEARCH_SUCCESS: 'MESSENGER/GET_CONVERSATIONS_SEARCH_SUCCESS',
  GET_CONVERSATIONS_SEARCH_FAILURE: 'MESSENGER/GET_CONVERSATIONS_SEARCH_FAILURE',

  GET_CONVERSATION_OPEN_REQUEST: 'MESSENGER/GET_CONVERSATION_OPEN_REQUEST',
  GET_CONVERSATION_OPEN_SUCCESS: 'MESSENGER/GET_CONVERSATION_OPEN_SUCCESS',
  GET_CONVERSATION_OPEN_FAILURE: 'MESSENGER/GET_CONVERSATION_OPEN_FAILURE',

  GET_CONVERSATION_OPEN_PAGINATION_REQUEST: 'MESSENGER/GET_CONVERSATION_OPEN_PAGINATION_REQUEST',
  GET_CONVERSATION_OPEN_PAGINATION_SUCCESS: 'MESSENGER/GET_CONVERSATION_OPEN_PAGINATION_SUCCESS',
  GET_CONVERSATION_OPEN_PAGINATION_FAILURE: 'MESSENGER/GET_CONVERSATION_OPEN_PAGINATION_FAILURE',

  OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_REQUEST: 'MESSENGER/OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_REQUEST',
  OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_SUCCESS: 'MESSENGER/OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_SUCCESS',
  OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_FAILURE: 'MESSENGER/OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_FAILURE',

  CREATE_CONVERSATION_FROM_MAIL_LINK_REQUEST: 'MESSENGER/CREATE_CONVERSATION_FROM_MAIL_LINK_REQUEST',
  CREATE_CONVERSATION_FROM_MAIL_LINK_SUCCESS: 'MESSENGER/CREATE_CONVERSATION_FROM_MAIL_LINK_SUCCESS',
  CREATE_CONVERSATION_FROM_MAIL_LINK_FAILURE: 'MESSENGER/CREATE_CONVERSATION_FROM_MAIL_LINK_FAILURE',

  ADD_DRAFT_MESSAGE_REQUEST: 'MESSENGER/ADD_DRAFT_MESSAGE_REQUEST',
  ADD_DRAFT_MESSAGE_SUCCESS: 'MESSENGER/ADD_DRAFT_MESSAGE_SUCCESS',
  ADD_DRAFT_MESSAGE_FAILURE: 'MESSENGER/ADD_DRAFT_MESSAGE_FAILURE',

  SET_FILTER_ITEM: 'MESSENGER/SET_FILTER_ITEM',

  ADD_TO_PENDING_MESSAGES: 'MESSENGER/ADD_TO_PENDING_MESSAGES',
  REMOVE_FROM_PENDING_MESSAGES: 'MESSENGER/REMOVE_FROM_PENDING_MESSAGES',

  LOCATE_MESSAGE_IN_CONV_REQUEST: 'MESSENGER/LOCATE_MESSAGE_IN_CONV_REQUEST',
  LOCATE_MESSAGE_IN_CONV_SUCCESS: 'MESSENGER/LOCATE_MESSAGE_IN_CONV_SUCCESS',
  LOCATE_MESSAGE_IN_CONV_FAILURE: 'MESSENGER/LOCATE_MESSAGE_IN_CONV_FAILURE',

  RESET_SCROLL_TO_MESSAGE: 'MESSENGER/RESET_SCROLL_TO_MESSAGE',

  CREATE_BG_TAG_REQUEST: 'MESSENGER/CREATE_BG_TAG_REQUEST',
  CREATE_BG_TAG_SUCCESS: 'MESSENGER/CREATE_BG_TAG_SUCCESS',
  CREATE_BG_TAG_FAILURE: 'MESSENGER/CREATE_BG_TAG_FAILURE',

  UPDATE_PROCESSED_TAG: 'MESSENGER/UPDATE_PROCESSED_TAG'
}
